<template>
  <header class="header">
    <div class="container-fluid">
      <div class="row h-100">
        <div class="col-md-12 d-flex justify-content-between">
          <div class="d-flex">
            <div class="d-flex align-items-center windows" @click="toggleFullscreen">
              <img v-if="isFullscreen" src="@/assets/icons/menu/windows_control/minimize_1.svg" alt="fullscreen-exit" />
              <img v-else src="@/assets/icons/menu/windows_control/maximize_1.svg" alt="fullscreen" />
              <!-- <i v-if="isFullscreen" class="fa fa-window-restore" aria-hidden="true"></i>
              <i v-else class="fa fa-window-maximize" aria-hidden="true"></i> -->
            </div>
            <Breadcrumb />
          </div>
          <MenuIcon />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Breadcrumb from '../../Breadcrumb.vue';
import { mapGetters, mapActions } from 'vuex';
import MenuIcon from '@/layouts/components/MenuIcon.vue';

export default {
  components: {
    Breadcrumb,
    MenuIcon,
  },
  computed: {
    ...mapGetters({
      isFullscreen: 'app/fullscreen',
    }),
  },
  methods: {
    ...mapActions({
      toggleFullscreen: 'app/TOGGLE_FULLSCREEN',
    }),
  },
};
</script>

<style lang="scss" scoped>
.header{
  height: 35px;
  background-color: #529beb;
  }
.windows{
  img{
    width: 35px;
  }
}
</style>
